import { Suspense, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, Outlet, useLocation } from "react-router";
import { Button, Menu, Sidebar, SidebarMobileHeader, ToastRegion } from "qw-ui-lib-v2";
import {
  QubeLogoOnlyBlueIcon,
  QubeWireLogoBlueFullIcon,
  LoaderSimpleIcon,
  DashboardIcon,
  MoreHorizontalIcon,
  LogoutIcon,
  HardDriveIcon,
  KeyIcon,
  ArrowLeftIcon,
} from "qw-ui-lib-v2/icons";
import { logoutUser } from "../../features/auth/authManager";

export const sidebarItems = [
  {
    label: "Fleet Management",
    icon: <DashboardIcon />,
    children: [
      { label: "Fleet Status", path: "/fleet/status" },
      { label: "Task Management", path: "/fleet/task-management" },
      { label: "Image Management", path: "/fleet/image-management" },
    ],
  },
  {
    label: "Devices",
    icon: <KeyIcon />,
    children: [{ label: "Credentials Manager", path: "/devices/credentials-manager" }],
  },
  {
    label: "Appliances",
    icon: <HardDriveIcon />,
    children: [{ label: "Qube ACS", path: "/appliance/acs" }],
  },
];

export function PageLayout() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { user } = useSelector((state) => state.auth);

  const userName = [user?.name, user?.lastName].filter(Boolean).join(" ");
  const userCompany = user?.companyName;

  return (
    <>
      <Sidebar open={open} onOpenChange={setOpen}>
        <Sidebar.Header>
          {({ collapsed }) => (collapsed ? <QubeLogoOnlyBlueIcon /> : <QubeWireLogoBlueFullIcon />)}
        </Sidebar.Header>
        <Sidebar.Nav>
          {sidebarItems?.map((item) =>
            item.children ? (
              <Sidebar.NavGroup key={item.label} label={item.label} icon={item.icon}>
                {item.children.map((child) => (
                  <Sidebar.NavItem key={child.path} isActive={pathname.startsWith(child.path)}>
                    <NavLink to={child.path}>
                      <Sidebar.Label>{child.label}</Sidebar.Label>
                    </NavLink>
                  </Sidebar.NavItem>
                ))}
              </Sidebar.NavGroup>
            ) : (
              <Sidebar.NavItem key={item.path} isActive={pathname.startsWith(item.path)}>
                <NavLink to={item.path}>
                  {item.icon}
                  <Sidebar.Label>{item.label}</Sidebar.Label>
                </NavLink>
              </Sidebar.NavItem>
            ),
          )}
        </Sidebar.Nav>
        <Sidebar.Actions className="flex">
          <Sidebar.Button
            className="truncate w-full"
            onClick={() => (window.location.href = `${process.env.QW_CINEMAS_URL}/admin`)}
          >
            <ArrowLeftIcon height={24} width={24} />
            Back To Cinema DB
          </Sidebar.Button>
        </Sidebar.Actions>
        <Sidebar.Footer>
          {userName && (
            <>
              <Sidebar.User name={userName} subtitle={userCompany} />
              <Menu>
                <Button variant="secondary" iconOnly>
                  <MoreHorizontalIcon />
                </Button>
                <Menu.Items style={{ minWidth: "auto" }}>
                  <Menu.Item onClick={logoutUser}>
                    <LogoutIcon color="#677a90" />
                    Logout
                  </Menu.Item>
                </Menu.Items>
              </Menu>
            </>
          )}
        </Sidebar.Footer>
      </Sidebar>
      <main className="main-content">
        <SidebarMobileHeader open={open} onOpenChange={setOpen}>
          <QubeWireLogoBlueFullIcon />
        </SidebarMobileHeader>
        <Suspense key={pathname} fallback={<LoaderSimpleIcon className="page-loader" />}>
          <Outlet />
        </Suspense>
      </main>
      <ToastRegion />
    </>
  );
}
